const FlashingCamera = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='89'
    height='68'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M41.001 67.438c-16.966 0-30.72-13.451-30.72-30.044S24.035 7.35 41.001 7.35c16.967 0 30.72 13.451 30.72 30.044s-13.754 30.044-30.72 30.044Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M52.161 18.06 28.096 15.9l3.835-8.556 18.05 1.619 2.18 9.095Z'
      fill='#CF8640'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m18.976 12.69-8.343-.748.382-4.08c.106-1.126 1.125-1.956 2.277-1.852l4.172.374c1.152.103 2 1.1 1.894 2.227l-.382 4.08Z'
      fill='#FFA926'
    />
    <mask
      id='flashing-camera__a'
      style={{
        maskType: 'alpha',
      }}
      maskUnits='userSpaceOnUse'
      x='11'
      y='25'
      width='53'
      height='35'
    >
      <path
        d='M11.678 25.34h51.967v34.449H11.678v-34.45Z'
        fill='#fff'
      />
    </mask>
    <g mask='url(#flashing-camera__a)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m11.678 55.746 44.89 4.026c2.335.209 4.405-1.532 4.626-3.889l2.451-26.139-49.117-4.405-2.85 30.407Z'
        fill='#FFAF84'
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.08 25.161.699 50.577C.483 52.869 2.176 54.894 4.48 55.1l7.822.701 2.772-29.565L3.08 25.161Z'
      fill='#CF8640'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m60.733 15.921-44.32-3.975-7.822-.701c-2.304-.207-4.342 1.452-4.554 3.705L3.033 25.66l11.992 1.076 48.494 4.349 1.004-10.71c.21-2.253-1.485-4.246-3.79-4.453Z'
      fill='#70210D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M55.028 37.521c-.845 9.013-9 15.65-18.215 14.822-9.215-.826-16.001-8.802-15.156-17.814.845-9.013 9-15.649 18.216-14.822 9.215.826 16 8.802 15.155 17.814Z'
      fill='#F0F0F0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M49.292 37.007c-.554 5.914-5.906 10.27-11.954 9.727-6.047-.543-10.5-5.777-9.946-11.691.555-5.915 5.907-10.27 11.954-9.727 6.048.542 10.5 5.777 9.946 11.69ZM20.7 21.477l-11.825-1.06.361-3.855 11.825 1.06-.361 3.855Z'
      fill='#FF620F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M67.689 9.404 74.062.307 73.75 11.33l10.624-3.697-6.878 8.739 10.816 3.116-10.816 3.117 6.878 8.739-10.624-3.697.312 11.024-6.373-9.098-6.373 9.098.311-11.024-10.624 3.697 6.878-8.74-10.816-3.116 10.816-3.116-6.878-8.74 10.624 3.698L61.316.307l6.373 9.097Z'
      fill='#FFCF0E'
    />
  </svg>
);

export default FlashingCamera;
